import React, { useContext, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { FirebaseContext } from '.';
import firebase from 'firebase/app';
import SignIn from './SignIn';
import Readlist from './Readlist';
import SignOut from './SignOut';
import Readlists from './Readlists';
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom';
import ConditionalDisplay from './ConditionalDisplay';
import NewReadlist from './NewReadlist';

const registerUserIfNeeded = async (user: any, firestore: firebase.firestore.Firestore, auth: firebase.auth.Auth, analytics: firebase.analytics.Analytics): Promise<void> => {
  try {
    if (user && auth.currentUser) {
      console.log('Received user credentials');
      const userRef = firestore.collection('users').doc(auth.currentUser.uid);

      const doc = await userRef.get();
      if (!doc.exists) {
        console.log('No doc exists for user', auth.currentUser.uid);
        analytics.logEvent('signup', {});
        await userRef.set({ uid: auth.currentUser.uid, mail: auth.currentUser.email });
      } else {
        console.log('Doc for user exists', doc.data());
      }
    }
  } catch (error) {
    console.log('Checking for user registration failed', error);
  }
};

const App = () => {
  const { auth, firestore, analytics } = useContext(FirebaseContext);
  const [ user ] = useAuthState(auth);

  useEffect(() => {
    registerUserIfNeeded(user, firestore, auth, analytics);
  }, [ user, firestore, auth, analytics ]);

  return (
    <div>
      <BrowserRouter>
        <nav className='navbar navbar-dark bg-dark py-3'>
          <div className='container-fluid justify-content-center justify-content-sm-between mx-5'>
            <Link to='/'><h1 className='navbar-brand'>Readlist</h1></Link>
            <div className='nav-item'>
              <ConditionalDisplay condition={ auth.currentUser !== null } trueDisplay= { <SignOut /> } falseDisplay={ <SignIn /> } />
            </div>
          </div>
        </nav>
      
        <div className='container my-5 col col-md-6'>
          { !!!user && <div className='alert alert-warning'>Please sign in before you can start to adding items to your readlist.</div> }
          { user && 
            <Switch>
              <Route path='/readlist/:readlistId'>
                <Readlist />
              </Route>
              <Route path='/'>
                <div className='container'>
                  <NewReadlist />
                  <Readlists />
                </div>
              </Route>
            </Switch> 
          }
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
